import React              from 'react';
import values             from '../../../../values';
import TransactionsScreen from '../../../../context/Transactions.context';

import { Components     } from './components';
import { useTranslation } from 'react-i18next';
import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView,
} from '../../../../components';

import './index.scss';

type Props = {
  rqData       : any;
  showModalData: any;
};

const FindTransactionScreen = (props: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestTransaction, setRequestTransaction } = React.useContext(TransactionsScreen);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={8} large={6} medium={7} className="search-and-filter-wrapper">
          <Components.Filter />
          <Components.Search />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.TRANSACTION_TABLE_HEADER.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestTransaction?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestTransaction({...requestTransaction, page: page,})}
            />
          </div>
        )}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default FindTransactionScreen;
